import { motion, AnimatePresence } from "framer-motion";

function SuccessSubmit({ isOpen, onClose }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0"
            style={{ background: "rgba(0,0,0,0.75)", backdropFilter: "blur(4px)" }}
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 16 }}
            className="relative w-full max-w-sm rounded-2xl p-8 flex flex-col items-center gap-5 text-center"
            style={{
              background: "#13131c",
              border: "1px solid rgba(255,255,255,0.10)",
              boxShadow: "0 24px 80px rgba(0,0,0,0.7), 0 0 60px rgba(124,58,237,0.12)",
            }}
          >
            {/* Icon */}
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center"
              style={{ background: "rgba(124,58,237,0.15)", border: "1px solid rgba(124,58,237,0.25)" }}
            >
              <img src="/src/img/wifi.png" alt="Success" className="w-7 h-7" />
            </div>

            {/* Text */}
            <div className="space-y-2">
              <h3 className="text-xl font-semibold text-white">🎉 Request Submitted!</h3>
              <p className="text-sm text-gray-400 leading-relaxed max-w-[280px]">
                Thanks for your suggestion! We'll review it and keep you updated on its progress.
              </p>
            </div>

            {/* Button */}
            <button
              onClick={onClose}
              className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white transition-all active:scale-[0.97]"
              style={{
                background: "linear-gradient(135deg,#7c3aed,#6d28d9)",
                boxShadow: "0 0 20px rgba(124,58,237,0.35)",
              }}
            >
              Explore More Features
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

export default SuccessSubmit;
